import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { changePanel, fetchRoofData } from '../RoofDataSlice/roofDataSlice';

type RoleState = {
	allowedActions: string[];
	allowedModes: string[];
}

const initialState: { data: RoleState } = {
	data: {
		allowedActions: [],
		allowedModes: [],
	},
};

const roleSlice = createSlice({
	name: 'roleData',
	initialState,
	reducers: {
		setRoleSliceState(state: { data: RoleState }, action: PayloadAction<Partial<RoleState>>) {
			state.data = { ...state.data, ...action.payload };
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchRoofData.fulfilled, (state, action) => {
				state.data.allowedActions = action.payload.allowedActions;
				state.data.allowedModes = action.payload.allowedModes;
			})
			.addCase(changePanel.fulfilled, (state, action) => {
				state.data.allowedActions = action.payload.allowedActions;
				state.data.allowedModes = action.payload.allowedModes;
			});
	},
});

export const { setRoleSliceState } = roleSlice.actions;
export default roleSlice.reducer;